import React, { Component } from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll'
import Slides from '../../images/main_cover.png';


class Hero extends Component {
    render() {
        return (
            <section id="home" className="hero hero-slider-wrapper hero-style-1">
                <div className="hero-slider">
                    <div className="slide" style={{ backgroundImage: `url(${Slides})` }}>
                        <div className="container">
                            <div className="row">
                                <div className="col col-md-10 col-sm-12 slide-caption">
                                    <div className="slide-subtitle">
                                        <h4>
                                            Profesyonellerin<br />
                                            Güvenilir<br />
                                            Çözüm Ortağı
                                        </h4>
                                    </div>
                                    <div className="slide-title">
                                        <h4>Teknoloji ve bilgi<br />
                                            güvenilir hizmetle buluşuyor.</h4>
                                    </div>
                                    <div className="btns d-flex flex-column align-items-start">
                                        <a href="https://danismanlik.alza.com.tr"
                                            className="template-btn go-contact-area mb-3"
                                            target="_blank"
                                            rel="noopener noreferrer">
                                            EĞİTİM & DANIŞMANLIK
                                        </a>
                                        <a href="https://makine.alza.com.tr"
                                            className="template-btn go-contact-area mb-3"
                                            target="_blank"
                                            rel="noopener noreferrer">
                                            MAKİNE
                                        </a>
                                        <a href="https://eticaret.alza.com.tr"
                                            className="template-btn go-contact-area"
                                            target="_blank"
                                            rel="noopener noreferrer">
                                            ONLİNE SATIŞ
                                        </a>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               
                <div className="white_svg">
                    <svg x="0px" y="0px" viewBox="0 186.5 1920 113.5">
                        <polygon points="0,300 655.167,210.5 1432.5,300 1920,198.5 1920,300 "></polygon>
                    </svg>
                </div>
            </section>
        )
    }
}

export default Hero;